var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c("el-header", [_vm._v("Pending Approval")]),
      _vm._v(" "),
      _c(
        "el-row",
        { attrs: { gutter: 24 } },
        [
          _c("el-col", { attrs: { span: 8 } }, [
            _c("div", { staticClass: "column-approval" }, [
              _c("div", { staticClass: "approval-count" }, [
                _vm._v(_vm._s(_vm.overtimeApproval))
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "approval-label" }, [_vm._v("Overtime")])
            ])
          ]),
          _vm._v(" "),
          _c("el-col", { attrs: { span: 8 } }, [
            _c("div", { staticClass: "column-approval" }, [
              _c("div", { staticClass: "approval-count" }, [
                _vm._v(_vm._s(_vm.leaveApproval))
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "approval-label" }, [
                _vm._v("Leave/Absence")
              ])
            ])
          ]),
          _vm._v(" "),
          _c("el-col", { attrs: { span: 8 } }, [
            _c("div", { staticClass: "column-approval" }, [
              _c("div", { staticClass: "approval-count" }, [
                _vm._v(_vm._s(_vm.timesheetApproval))
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "approval-label" }, [
                _vm._v("Timesheet")
              ])
            ])
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }